<template>
  <div class="signature">
    <TopBack :title="'个性签名'" :saveShow="true" :values="signature" @saveBtn="saveHandle" />
    <div class="form">
      <van-cell-group inset>
        <van-field
          v-model="signature"
          autosize
          maxlength="200"
          rows="4"
          type="textarea"
          placeholder="输入您的个性签名"
          show-word-limit
        />
      </van-cell-group>
    </div>
  </div>
</template>
<script setup name="Signature">
import { ref, computed, onMounted } from "vue";
import { showToast } from "vant";
import { useStore } from "vuex";
import { editUserInfo } from "@/assets/api/user";
const store = useStore();
const userInfo = computed(() => store.state.userJs.userInfo);
const signature = ref("");

function saveHandle() {
  editUserInfo({
    signature: signature.value,
  }).then((res) => {
    showToast("修改成功");
    store.state.userJs.userInfo.signature = signature.value;
  });
}
onMounted(() => {
  signature.value = userInfo.value ? userInfo.value.signature : "";
});
</script>

<style scoped>
.signature {
  background: #fafafa;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.form {
  margin: 5.33vw 2.66vw;
}
</style>
<style scoped>
.signature .van-field {
  border-radius: 8px;
}
.signature /deep/ .van-field__word-num {
  color: #d8ad6d;
}
</style>
